define('lq/events/actions/sms',[
    'lq',
    'lq/events/actions/eventAction'
], function(lq, EventAction) {
    'use strict';
        
    function Sms(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(Sms, EventAction);

    Sms.typeName = 'Sms';

    Sms.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
        
    Sms.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'SendSms',
            morphId: this.eventData.command
        };
    };

    Sms.prototype.execute = function (continuation) {
        if (this.eventIsEnabled('sent'))
            this.triggerEvent('sent', continuation);
        else
            continuation();
    };

    return Sms;
});
